"use client";

import Image from "next/image";
import { useEffect, useState } from "react";

const plateformRatio = [
  {
    icon: (
      <svg
        height="20"
        width="20"
        viewBox="0 0 256 256"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none">
          <rect
            height="256"
            width="256"
            fill="url(#skillIconsInstagram0)"
            rx="60"
          />
          <rect
            height="256"
            width="256"
            fill="url(#skillIconsInstagram1)"
            rx="60"
          />
          <path
            d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604h.031Zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396c0 26.688-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413c0-26.704.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5c3.5-3.5 6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563v.025Zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12v.004Zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355c0 28.361 22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355h.002Zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334c-18.41 0-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334Z"
            fill="#fff"
          />
          <defs>
            <radialGradient
              id="skillIconsInstagram0"
              cx="0"
              cy="0"
              gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)"
              gradientUnits="userSpaceOnUse"
              r="1"
            >
              <stop stopColor="#FD5" />
              <stop offset=".1" stopColor="#FD5" />
              <stop offset=".5" stopColor="#FF543E" />
              <stop offset="1" stopColor="#C837AB" />
            </radialGradient>
            <radialGradient
              id="skillIconsInstagram1"
              cx="0"
              cy="0"
              gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)"
              gradientUnits="userSpaceOnUse"
              r="1"
            >
              <stop stopColor="#3771C8" />
              <stop offset=".128" stopColor="#3771C8" />
              <stop offset="1" stopColor="#60F" stopOpacity="0" />
            </radialGradient>
          </defs>
        </g>
      </svg>
    ),
    platform: "Instagram",
    ratio: 3,
    position:
      "top-10 left-3 sm:top-16 sm:left-10 lg:top-20 lg:left-20 rotate-[11deg]",
  },
  {
    icon: (
      <svg
        height="20"
        width="20"
        viewBox="0 0 256 256"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M256 128C256 57.308 198.692 0 128 0C57.308 0 0 57.307 0 128c0 63.888 46.808 116.843 108 126.445V165H75.5v-37H108V99.8c0-32.08 19.11-49.8 48.347-49.8C170.352 50 185 52.5 185 52.5V84h-16.14C152.958 84 148 93.867 148 103.99V128h35.5l-5.675 37H148v89.445c61.192-9.602 108-62.556 108-126.445"
          fill="#1877F2"
        />
        <path
          d="m177.825 165l5.675-37H148v-24.01C148 93.866 152.959 84 168.86 84H185V52.5S170.352 50 156.347 50C127.11 50 108 67.72 108 99.8V128H75.5v37H108v89.445A128.959 128.959 0 0 0 128 256a128.9 128.9 0 0 0 20-1.555V165h29.825"
          fill="#FFF"
        />
      </svg>
    ),
    platform: "Facebook",
    ratio: 4,
    position:
      "top-10 right-3 sm:top-16 sm:right-10 lg:top-20 lg:right-20 rotate-[-11deg]",
  },
  {
    icon: (
      <svg
        height="20"
        width="20"
        viewBox="0 0 256 180"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M250.346 28.075A32.18 32.18 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.18 32.18 0 0 0 22.657-22.657c6.338-35.348 8.291-89.1-.164-123.134Z"
          fill="red"
        />
        <path d="m102.421 128.06l66.328-38.418l-66.328-38.418z" fill="#FFF" />
      </svg>
    ),
    platform: "Youtube",
    ratio: 2,
    position:
      "bottom-14 right-3 sm:bottom-20 sm:right-10 lg:bottom-24 lg:right-20 rotate-[11deg]",
  },
  {
    icon: (
      <svg
        height="20"
        width="20"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.294 6.928L14.357 1h-1.2L8.762 6.147L5.25 1H1.2l5.31 7.784L1.2 15h1.2l4.642-5.436L10.751 15h4.05L9.294 6.928ZM7.651 8.852l-.538-.775L2.832 1.91h1.843l3.454 4.977l.538.775l4.491 6.47h-1.843l-3.664-5.28Z"
          fill="currentColor"
        />
      </svg>
    ),
    platform: "Twitter",
    ratio: 2,
    position:
      "bottom-14 left-3 sm:bottom-20 sm:left-10 lg:bottom-24 lg:left-20 rotate-[-11deg]",
  },
  {
    icon: (
      <svg
        height="20"
        width="20"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none">
          <path
            d="M22.064 17.711a.827.827 0 0 0 .11-1.552a15 15 0 0 1-2.756-1.654a1.334 1.334 0 0 1 .09-2.189l1.207-.765a1.333 1.333 0 1 0-1.43-2.251L18 10.116V7A6 6 0 1 0 6 7v3.116L4.712 9.3a1.333 1.333 0 1 0-1.43 2.251l1.207.765a1.334 1.334 0 0 1 .09 2.189a15 15 0 0 1-2.756 1.654a.828.828 0 0 0 .11 1.552l1.97.4a.82.82 0 0 1 .57.988a1.282 1.282 0 0 0 1.455 1.575l.626-.1a2.85 2.85 0 0 1 2.48.8A4.7 4.7 0 0 0 12 23a4.7 4.7 0 0 0 2.964-1.63a2.85 2.85 0 0 1 2.48-.8l.627.1a1.282 1.282 0 0 0 1.455-1.57a.82.82 0 0 1 .57-.988z"
            fill="#ffef5e"
          />
          <path
            d="M11.999 1a6.02 6.02 0 0 0-6 6v3.116L4.712 9.3a1.334 1.334 0 0 0-1.43 2.252l1.207.765a1.334 1.334 0 0 1 .09 2.189a15 15 0 0 1-2.756 1.654a.828.828 0 0 0 .11 1.552l1.97.4q.06.026.115.059L17.525 4.668A6.02 6.02 0 0 0 11.999 1"
            fill="#fff9bf"
          />
          <path
            d="M22.064 17.711a.827.827 0 0 0 .11-1.552a15 15 0 0 1-2.756-1.654a1.334 1.334 0 0 1 .09-2.189l1.207-.765a1.333 1.333 0 1 0-1.43-2.251L18 10.116V7A6 6 0 1 0 6 7v3.116L4.712 9.3a1.333 1.333 0 1 0-1.43 2.251l1.207.765a1.334 1.334 0 0 1 .09 2.189a15 15 0 0 1-2.756 1.654a.828.828 0 0 0 .11 1.552l1.97.4a.82.82 0 0 1 .57.988a1.282 1.282 0 0 0 1.455 1.575l.626-.1a2.85 2.85 0 0 1 2.48.8A4.7 4.7 0 0 0 12 23a4.7 4.7 0 0 0 2.964-1.63a2.85 2.85 0 0 1 2.48-.8l.627.1a1.282 1.282 0 0 0 1.455-1.57a.82.82 0 0 1 .57-.988z"
            stroke="#191919"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    ),
    platform: "Snapchat",
    ratio: 1,
    position:
      "top-40 right-1 xs:top-28 xs:right-2 sm:top-48 sm:right-4 lg:top-56 lg:right-10 rotate-[11deg]",
  },
  {
    icon: (
      <svg
        height="20"
        width="20"
        viewBox="0 0 128 128"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M116 3H12a8.91 8.91 0 0 0-9 8.8v104.42a8.91 8.91 0 0 0 9 8.78h104a8.93 8.93 0 0 0 9-8.81V11.77A8.93 8.93 0 0 0 116 3z"
          fill="#0076b2"
        />
        <path
          d="M21.06 48.73h18.11V107H21.06zm9.06-29a10.5 10.5 0 1 1-10.5 10.49a10.5 10.5 0 0 1 10.5-10.49m20.41 29h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75v32H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53z"
          fill="#fff"
        />
      </svg>
    ),
    platform: "LinkedIn",
    ratio: 2,
    position:
      "xs:top-28 xs:left-3 xs:rotate-[10deg] top-40 left-1 sm:top-44 sm:left-4 lg:top-52 lg:left-10 rotate-[-10deg]",
  },
];

const platforms = [
  {
    id: 1,
    name: "Instagram",
    ratios: [
      { label: "1:1", src: "/assets/homePage/oneCreative/instagram-1-1.svg" },
      { label: "4:5", src: "/assets/homePage/oneCreative/instagram-4-5.svg" },
      { label: "9:16", src: "/assets/homePage/oneCreative/instagram-9-16.svg" },
    ],
  },
  {
    id: 2,
    name: "Facebook",
    ratios: [
      { label: "1:1", src: "/assets/homePage/oneCreative/facebook-1-1.svg" },
      { label: "4:5", src: "/assets/homePage/oneCreative/facebook-4-5.svg" },
      { label: "16:9", src: "/assets/homePage/oneCreative/facebook-16-9.svg" },
      { label: "9:16", src: "/assets/homePage/oneCreative/facebook-9-16.svg" },
    ],
  },
  {
    id: 3,
    name: "Snapchat",
    ratios: [
      { label: "9:16", src: "/assets/homePage/oneCreative/snapchat-9-16.svg" },
    ],
  },
  {
    id: 4,
    name: "Youtube",
    ratios: [
      { label: "16:9", src: "/assets/homePage/oneCreative/youtube-16-9.svg" },
      { label: "9:16", src: "/assets/homePage/oneCreative/youtube-9-16.svg" },
    ],
  },
  {
    id: 5,
    name: "Twitter",
    ratios: [
      { label: "1:1", src: "/assets/homePage/oneCreative/x-1-1.svg" },
      { label: "16:9", src: "/assets/homePage/oneCreative/x-16-9.svg" },
    ],
  },
  {
    id: 6,
    name: "LinkedIn",
    ratios: [
      { label: "1:1", src: "/assets/homePage/oneCreative/linkedin-1-1.svg" },
      { label: "16:9", src: "/assets/homePage/oneCreative/linkedin-16-9.svg" },
    ],
  },
];
const OneCreativeEveryPlatform = () => {
  const [currentPlatform, setCurrentPlatform] = useState(platforms[0]);
  const [currentRatio, setCurrentRatio] = useState(platforms[0].ratios[0]);

  const handleBrandClick = (platform) => {
    const next = platforms.find((p) => p.name === platform);
    setCurrentPlatform(next);
    setCurrentRatio(next.ratios[0]);
  };
  const handleRatioClick = (ratio) => {
    setCurrentRatio(ratio);
  };

  const currentPlatformIcon = plateformRatio.find(
    (p) => p.platform === currentPlatform?.name,
  )?.icon;

  useEffect(() => {
    let timer = setInterval(() => {
      setCurrentRatio((prev) => {
        const ratios = currentPlatform.ratios;
        const nextIdx = (ratios.indexOf(prev) + 1) % ratios.length;
        return ratios[nextIdx];
      });
    }, 2000);

    return () => {
      clearInterval(timer);
    };
  }, [currentPlatform]);
  return (
    <section className="relative bg-[#F5F5F7] py-8 lg:py-0  lg:pb-20 px-5 sm:px-6 lg:px-20">
      <div className="bg-white flex flex-col lg:flex-row lg:items-end justify-between gap-8 lg:gap-10 rounded-[20px] lg:rounded-[32px] px-3 sm:px-6 lg:px-12 py-6 lg:py-8">
        <article className="flex flex-col items-center lg:items-start gap-3 sm:gap-4 w-full lg:max-w-[580px]">
          {/* Mobile pill */}
          <div className="lg:hidden px-2 py-1 inline-flex items-center gap-2 rounded-full font-kalam border border-zinc-200 text-[#292929] text-[10px] sm:text-[11px] italic font-bold">
            <span className="inline-flex items-center justify-center bg-[#7F7FFF]/20 rounded-full w-3.5 h-3.5">
              <span className="block w-1.5 h-1.5 rounded-full bg-[#7F7FFF]" />
            </span>
            <div className="h-3 text-center justify-start text-zinc-600 text-[10px] sm:text-[11px] font-bold font-['Kalam'] leading-4 tracking-wide">
              Resizing Feature
            </div>
          </div>
          {/* Desktop pill */}
          <div className="hidden lg:inline-flex px-2 py-1 items-center gap-2 rounded-full  font-kalam border border-zinc-200 text-[#292929] text-[12px] italic font-bold">
            <span className="inline-flex items-center justify-center bg-[#7F7FFF]/20 rounded-full w-3.5 h-3.5">
              <span className="block w-1.5 h-1.5 rounded-full bg-[#7F7FFF]" />
            </span>
            <div className="h-3 text-center justify-start text-zinc-600 text-xs font-bold font-['Kalam']  leading-4 tracking-wide">
              Smart Resizing
            </div>
          </div>

          {/* Mobile heading */}
          <h2 className="lg:hidden text-[24px] leading-[1.15] sm:text-[32px] md:text-[40px] font-medium tracking-[-1px] text-[#242424] text-center">
            Watch the ad resize itself.
          </h2>
          {/* Desktop heading */}
          <h2 className="hidden lg:block text-5xl 3xl:text-[64px] 4xl:text-[80px] font-medium tracking-[-1px] text-[#242424] lg:text-left leading-[1.15]">
            One creative.
            <br />
            Every platform.
          </h2>

          <p className="lg:hidden text-[#6B6B6B] text-[14px] sm:text-[16px] mx-auto font-normal tracking-[-0.3px] text-center">
            Imagive knows the specs for 15+ ad surfaces. Pick one and see
            exactly how your creative lands — no re-export, no re-crop, no
            re-design.
          </p>

          <div className="relative mt-8 lg:mt-10 w-full max-w-[550px]">
            {/* "Click a platform" hint, sitting above the circle box */}
            <div className="absolute -top-7 sm:-top-9 lg:-top-10 left-[52%] sm:left-[55%] text-[#130FEC] text-sm sm:text-base lg:text-lg font-bold font-['Kalam'] leading-6 z-20 whitespace-nowrap">
              Click a platform.
            </div>
            <span className="absolute -top-6 sm:-top-7 lg:-top-8 left-[34%] sm:left-[38%] z-20">
              <Image
                src="/assets/homePage/oneCreative/arrow.svg"
                alt=""
                width={100}
                height={100}
                className="w-16 sm:w-20 lg:w-[100px] h-auto"
              />
            </span>

            <div className="relative w-full max-w-[550px] aspect-square lg:aspect-auto lg:h-[470px] overflow-hidden bg-[#E1E3F5] rounded-[24px] sm:rounded-[28px] lg:rounded-[35px]">
              {/* Decorative concentric rings */}
              <div className="absolute w-[105%] aspect-square sm:w-[500px] sm:h-[500px] sm:aspect-auto lg:w-[560px] lg:h-[560px] rounded-full border-dashed border-[1px] border-[#A198A3]/40 lg:border-[#A198A3] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
              <div className="absolute w-[75%] aspect-square sm:w-[360px] sm:h-[360px] sm:aspect-auto lg:w-[420px] lg:h-[420px] rounded-full border-dashed border-[1px] border-[#A198A3]/40 lg:border-[#A198A3] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
              <div className="absolute w-[45%] aspect-square sm:w-[230px] sm:h-[230px] sm:aspect-auto lg:w-[260px] lg:h-[260px] rounded-full border-dashed border-[1px] border-[#A198A3]/40 lg:border-[#A198A3] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <p className="absolute top-1/2 left-1/2 font-light -translate-x-1/2 -translate-y-1/2 text-center text-[#242424] text-xs sm:text-sm leading-relaxed whitespace-nowrap">
                  Supports <span className="font-semibold">15+</span>
                  <br />
                  <span className="font-semibold">platforms</span> & ad formats
                </p>
              </div>

              {/* Platform pills */}
              {plateformRatio.map((item, index) => {
                const isActive = item.platform === currentPlatform?.name;
                return (
                  <button
                    key={index}
                    className={`absolute ${item.position} ${
                      isActive
                        ? "shadow-[0_0_24px_4px_rgba(127,127,255,0.55)]  ring-[1.5px] ring-[#7F7FFF]/60"
                        : "shadow-lg"
                    } bg-white z-10 rounded-full flex items-center gap-1 sm:gap-1.5 px-2 py-1 sm:px-3 sm:py-2`}
                    onClick={() => handleBrandClick(item.platform)}
                  >
                    <span className="flex items-center justify-center [&_svg]:w-3 [&_svg]:h-3 sm:[&_svg]:w-5 sm:[&_svg]:h-5">
                      {item.icon}
                    </span>
                    <span className="text-[#242424] text-[10px] sm:text-sm font-medium leading-relaxed">
                      {item.platform}
                    </span>
                    <hr className="w-[1px] h-3 sm:h-4 bg-[#242424] mx-0.5 sm:mx-1" />
                    <span className="text-[#242424] text-[9px] sm:text-xs font-medium leading-relaxed">
                      {item.ratio}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </article>

        <article className="flex flex-col items-center lg:items-stretch gap-4 sm:gap-6 w-full lg:max-w-[580px]">
          <p className="hidden  max-w-[520px]  lg:block text-[#6D6D6D] text-[14px] sm:text-[16px] lg:text-lg 3xl:text-xl 4xl:text-2xl mb-0 lg:mb-14">
            Automatically resize, adapt, and optimize creatives for every aspect
            ratio, placement, and ad surface - without redesigning from scratch.
          </p>

          <div className="flex flex-col w-full max-w-[550px] aspect-square lg:aspect-auto lg:h-[470px] overflow-hidden border border-zinc-200 rounded-[24px] sm:rounded-[28px] lg:rounded-[35px] bg-white">
            {/* Content padding */}
            <div className="flex items-center p-4 sm:p-4 lg:px-5 lg:pt-5 gap-2 shrink-0">
              <span className="flex items-center justify-center [&_svg]:w-5 [&_svg]:h-5 sm:[&_svg]:w-6 sm:[&_svg]:h-6">
                {currentPlatformIcon}
              </span>

              <span className="text-[#242424] text-sm sm:text-base font-semibold">
                {currentPlatform?.name}
              </span>
            </div>

            {/* Image section with independent padding */}
            <div className="relative flex items-center justify-center flex-1 min-h-0">
              <div className="w-full h-full rounded-[16px] lg:rounded-[20px] overflow-hidden">
                {currentRatio && (
                  <Image
                    key={`${currentPlatform?.name}-${currentRatio.label}`}
                    src={currentRatio.src}
                    alt={`${currentPlatform?.name} ${currentRatio.label} preview`}
                    width={550}
                    height={470}
                    unoptimized
                    priority
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
            </div>

            {/* Bottom pills */}
            <div className="flex flex-wrap items-center justify-start gap-2 p-4 sm:p-4 lg:px-5 lg:pb-5 shrink-0">
              {currentPlatform?.ratios.map((ratio) => {
                const isActive = ratio.label === currentRatio?.label;

                return (
                  <button
                    key={ratio.label}
                    onClick={() => handleRatioClick(ratio)}
                    className={`px-3 py-1 lg:py-1.5 border rounded-full text-xs sm:text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-[#F0F0FF] text-[#242424] border-[#7F7FFF]"
                        : "bg-white text-[#242424] border-zinc-300 hover:border-zinc-500"
                    }`}
                  >
                    {ratio.label}
                  </button>
                );
              })}
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default OneCreativeEveryPlatform;
